export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'it', 'de'];

const MODULE_ORDER = [
  'appShell',
  'parksCatalog',
  'status',
  'parkExperience',
  'passes',
  'content',
  'weather',
  'openingHours',
  'bottomNavigation',
  'legal',
  'signupBanner',
  'showsDrone',
  'accessibility',
  'parking',
  'news',
  'auth',
];

const localeModuleContext = require.context(
  './',
  true,
  /^\.\/[^/]+\/(?:[^/]+-(en|fr|es|it|de)|(?:en|fr|es|it|de))\.json$/
);

const deepMerge = (target, source) => {
  const output = { ...(target || {}) };

  Object.entries(source || {}).forEach(([key, value]) => {
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      output[key] &&
      typeof output[key] === 'object' &&
      !Array.isArray(output[key])
    ) {
      output[key] = deepMerge(output[key], value);
      return;
    }

    output[key] = value;
  });

  return output;
};

const getModuleNameFromPath = (modulePath) => modulePath.split('/')[1];

const getLanguageFromPath = (modulePath) => {
  const match = modulePath.match(/(?:[^/]+-)?(en|fr|es|it|de)\.json$/);
  return match ? match[1] : null;
};

const normalizeLocaleModule = (loadedModule) => loadedModule?.default || loadedModule || {};

const allModulePaths = localeModuleContext.keys();

const discoveredModules = Array.from(
  new Set(allModulePaths.map(getModuleNameFromPath).filter(Boolean))
).sort();

const orderedModules = [
  ...MODULE_ORDER.filter((moduleName) => discoveredModules.includes(moduleName)),
  ...discoveredModules.filter((moduleName) => !MODULE_ORDER.includes(moduleName)),
];

const translations = SUPPORTED_LANGUAGES.reduce((accumulator, language) => {
  accumulator[language] = {};
  return accumulator;
}, {});

orderedModules.forEach((moduleName) => {
  const modulePaths = allModulePaths
    .filter((modulePath) => getModuleNameFromPath(modulePath) === moduleName)
    .sort();

  modulePaths.forEach((modulePath) => {
    const language = getLanguageFromPath(modulePath);
    if (!language || !SUPPORTED_LANGUAGES.includes(language)) {
      return;
    }

    translations[language] = deepMerge(
      translations[language],
      normalizeLocaleModule(localeModuleContext(modulePath))
    );
  });
});

export default translations;
